import { TextNode } from '../textNodes'

const NewPaybarBasementTextCancellationText = ({ product }) => (
  <div className="subscriptionLicense">
    <TextNode html={ I18n.t(`subscriptionCancel.cancellationText.${product}`) } />
  </div>
)

export default NewPaybarBasementTextCancellationText
